// extracted by mini-css-extract-plugin
export default {"searchInput":"Search_searchInput__JV0cW","search":"Search_search__JtbP4","hidden":"Search_hidden__RhbQa"};